import { fetchMetaData, fetchInfo, fetchPXQ, fetchData } from './apiFetching';
import { setSelectionFile, setSelectionLang, initQuerySelectionValues, setStubHeadingFromMetaData } from './querySelection';
import { setColumnFromMetadata } from './pivot';
import { errorEmptyParams } from './errors';
export const initStore = () => async (dispatch, getState) => {
    const { config } = getState();
    const lang = config.lang ? config.lang : 'es';
    const { path } = config;
    let file = '';
    dispatch(errorEmptyParams(false));
    try {
        if (path && path.length === 1) {
            await dispatch(fetchPXQ(path[0]));
            await dispatch(fetchMetaData());
            await dispatch(fetchInfo());
            if (getState().selection.heading.length === 0 && getState().selection.stub.length === 0) {
                const { stub, heading } = getState().metadata;
                dispatch(setStubHeadingFromMetaData(stub, heading));
                dispatch(setColumnFromMetadata(stub, heading));
            }
            else {
                dispatch(setColumnFromMetadata(getState().selection.stub, getState().selection.heading));
            }
            await dispatch(fetchData());
        } else if (path && path.length > 1) {
            file = path.join('/');
            dispatch(emptyData());
            dispatch(setSelectionLang(lang));
            dispatch(setSelectionFile(file));
            await dispatch(fetchMetaData());
            const { stub, heading } = getState().metadata;
            dispatch(setStubHeadingFromMetaData(stub, heading));
            dispatch(setColumnFromMetadata(stub, heading));
            await dispatch(initQuerySelectionValues(getState().metadata.variables));
        } else {
            dispatch(errorEmptyParams());
            console.log(' No se ha proporcionado un archivo config valido que contenga un pxq o, bd y px');
        }
    } catch (e) {
        console.log('No se ha proporcionado un archivo config valido que contenga un pxq o, bd y px');
        dispatch(errorEmptyParams());
    }
    dispatch(isLoaded());
}

export const setConfig = (config) => {
    return {
        type: 'SET_CONFIG',
        payload: config
    }
}

const isLoaded = () => {
    return {
        type: 'IS_LOADED',
        payload: false
    }
}

export const collapseTabOptions = (isCollapse) => {
    return {
        type: 'COLLAPSE',
        payload: isCollapse
    }
}

export const collapseAll = (areAllCollase) => {
    return {
        type: 'SET_COLLAPSE_ALL',
        payload: areAllCollase
    }
}

export const enableDD = (enableDD) => {
    return {
        type: 'SET_DD_ENABLED',
        payload: enableDD
    }
}

export const emptyData = () => {
    return {
        type: 'EMPTY_DATA',
        payload: null
    }
}